import './App.css';
import CV from "./components/CV";
import CVBackgroundVideo from "./components/CVBackgroundVideo";

function App() {
    return (<div className="App">
        <CVBackgroundVideo/>
        <CV/>
    </div>);
}

export default App;
